var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popupWrap",
    class: {
      'active': _vm.openOrClose
    },
    on: {
      "click": _vm.dimmedClickHandler
    }
  }, [_c('div', {
    ref: "contentWrap",
    staticClass: "contentWrap"
  }, [_c('h2', [_vm._v("작업 이력")]), _c('div', {
    staticClass: "scrlWrap"
  }, [_c('table', {
    staticClass: "list"
  }, [_c('colgroup', [_c('col', {
    style: {
      width: '135px'
    }
  }), _c('col', {
    style: {
      width: '60px'
    }
  }), _c('col', {
    style: {
      width: '90px'
    }
  }), _c('col', {
    style: {
      width: '*'
    }
  }), _c('col', {
    style: {
      width: '80px'
    }
  }), _c('col', {
    style: {
      width: '106px'
    }
  })]), _vm._m(0), _c('tbody', [_vm.srchList.length == 0 ? _c('tr', [_c('td', {
    staticClass: "noneData",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("작업 이력이 없습니다.")])]) : _vm._e(), _vm._l(_vm.srchList, function (_ref, idx) {
    var createdDate = _ref.createdDate,
        userName = _ref.userName,
        content = _ref.content,
        memo = _ref.memo,
        processId = _ref.processId,
        id = _ref.id,
        publicActive = _ref.publicActive,
        thumbnail = _ref.thumbnail;
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.formatDate(createdDate)))]), _c('td', [_vm._v(_vm._s(publicActive > 0 ? "공개" : "저장"))]), _c('td', [_vm._v(_vm._s(_vm.publishType[publicActive]))]), _c('td', [_c('p', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(memo))])])]), _c('td', [content !== null && thumbnail && _vm.processData.processType == 'NORMAL' ? _c('button', {
      staticClass: "btnLoad",
      on: {
        "click": function ($event) {
          return _vm.viewImage(`data:image/jpeg;base64,${thumbnail}`);
        }
      }
    }, [_vm._v("미리보기")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(userName))])]);
  })], 2)])]), _c('close-btn', {
    attrs: {
      "closeHandler": _vm.clickCloseHandler
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.imageUrl !== false,
      expression: "imageUrl !== false"
    }],
    staticClass: "imgViewer",
    on: {
      "click": function ($event) {
        _vm.imageUrl = false;
      }
    }
  }, [_c('div', {
    staticClass: "overflow"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("일시")]), _c('th', [_vm._v("분류")]), _c('th', [_vm._v("공개")]), _c('th', [_vm._v("메모")]), _c('th', [_vm._v("-")]), _c('th', [_vm._v("등록자")])])]);

}]

export { render, staticRenderFns }